import {
  CountryOfficeCount,
  EmployeeLocation,
} from '@aibees/elephant/components/employees-trends-location';

export interface CompanyLocationStatsProps {
  className?: string;
  employees: EmployeeLocation[];
  offices: CountryOfficeCount[];
  hoveredItem?: string;
  statsType: CompanyStats;
  handleChangeStats: (value: CompanyStats) => void;
}

export enum CompanyStats {
  Employee = 'Employee',
  Office = 'Office',
}
